import { render, staticRenderFns } from "./JobOfferSettingsList.vue?vue&type=template&id=85fba894&scoped=true&"
import script from "./JobOfferSettingsList.vue?vue&type=script&lang=js&"
export * from "./JobOfferSettingsList.vue?vue&type=script&lang=js&"
import style0 from "./JobOfferSettingsList.vue?vue&type=style&index=0&id=85fba894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fba894",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85fba894')) {
      api.createRecord('85fba894', component.options)
    } else {
      api.reload('85fba894', component.options)
    }
    module.hot.accept("./JobOfferSettingsList.vue?vue&type=template&id=85fba894&scoped=true&", function () {
      api.rerender('85fba894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/JobOffers/JobOfferSettingsList.vue"
export default component.exports